import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle, faExclamationCircle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const CBResult = ({
  status = 'info', // 'success', 'error', 'info', 'warning'
  title,
  subTitle,
  extra, // ReactNode for additional buttons/content
  icon, // Custom icon ReactNode
  className = '',
}) => {
  let statusIcon;
  let iconColorClass = '';

  if (icon) {
    statusIcon = icon;
  } else {
    switch (status) {
      case 'success':
        statusIcon = <FontAwesomeIcon icon={faCheckCircle} />;
        iconColorClass = 'text-[#FF6709]';
        break;
      case 'error':
        statusIcon = <FontAwesomeIcon icon={faTimesCircle} />;
        iconColorClass = 'text-red-500';
        break;
      case 'warning':
        statusIcon = <FontAwesomeIcon icon={faExclamationCircle} />;
        iconColorClass = 'text-yellow-500';
        break;
      case 'info':
      default:
        statusIcon = <FontAwesomeIcon icon={faInfoCircle} />;
        iconColorClass = 'text-blue-500';
        break;
    }
  }

  return (
    <div className={`flex flex-col items-center justify-center p-8 text-center ${className}`}>
      {statusIcon && (
        <div className={`text-6xl mb-6 ${iconColorClass}`}>
          {statusIcon}
        </div>
      )}
      {title && (
        <h2 className="text-2xl font-semibold mb-2 text-gray-800">{title}</h2>
      )}
      {subTitle && (
        <p className="text-base text-gray-500 mb-6">{subTitle}</p>
      )}
      {extra && (
        <div className="mt-6">{extra}</div>
      )}
    </div>
  );
};

export { CBResult };